
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/esser",
      function () {
        return require("private-next-pages/esser.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/esser"])
      });
    }
  